import { CampaignStrategy } from '../types/campaign-strategy';

export const needsSku = new Set([
  CampaignStrategy.Similars,
  CampaignStrategy.CompleteTheLook,
  CampaignStrategy.ShopTheLook,
]);
